import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/contact/contact-client.tsx");
